import { render } from "./UserItemList.vue?vue&type=template&id=6f5c9cbc&scoped=true"
import script from "./UserItemList.vue?vue&type=script&lang=js"
export * from "./UserItemList.vue?vue&type=script&lang=js"

import "./UserItemList.vue?vue&type=style&index=0&id=6f5c9cbc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5c9cbc"]])

export default __exports__